import styled from 'styled-components';
import { BodySmallText, FontWeight } from '@prisjakt/ui/text/variants';

export const P = styled(BodySmallText).attrs({ container: 'p' })`
  text-align: justify;
`;

export const Text = styled(BodySmallText)`
  text-align: justify;
`;

export const Strong = styled(BodySmallText).attrs({
  container: 'strong',
  weight: FontWeight.HEAVIER,
})``;
